import TopContentBBQMessage from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopContentBBQMessage/TopContentBBQMessage';

export default TopContentBBQMessage;
